export const COUPON_BOOK_DATA_REQUEST = "COUPON_BOOK_DATA_REQUEST"
export const COUPON_BOOK_DETAIL_DATA_REQUEST = "COUPON_BOOK_DETAIL_DATA_REQUEST"
export const UPDATE_PAGINATION_COUPON_BOOK_LIST = "UPDATE_PAGINATION_COUPON_BOOK_LIST"
export const UPDATE_COUPON_BOOK_LOADING = "UPDATE_COUPON_BOOK_LOADING"
export const UPDATE_DETAIL_PAGINATION_COUPON_BOOK_LIST = "UPDATE_DETAIL_PAGINATION_COUPON_BOOK_LIST"